import { Injectable, Type } from '@angular/core';
import { FieldFactory } from '../field-factory.interface';
import * as fields from '../../models/settings/settings-fields-index';

import { FieldDataInterface } from '../../models/settings/settings-custom-form-field-data.model';
import { SettingsCustomFormFieldData } from '../../models/settings/settings-custom-form-field-data.class'

import * as fieldComponents from '../../components/fields/date-v1/date-v1-index';

@Injectable({
    providedIn: 'root'
  })
export class DateV1FieldFactory implements FieldFactory {
    constructor(){}
    type: string = 'date-v1';
    menuTitle: string = "Date";
    deprecated: boolean = false;

    /**
     * 
     * @param field the object data of the field
     * @returns DateV1Field instance that extends SettingsCustomFormFieldData
     */
    createFillFormFieldData(field?: FieldDataInterface): SettingsCustomFormFieldData {
        // if (field) {
        //     return new fields.DateV1Field(this.type, field);
        // }
        // else {
            return new fields.SettingsDateV1Field(this.type, 0);
        // }
    }

    createSettingsFormField(position: number) : SettingsCustomFormFieldData {
        return new fields.SettingsDateV1Field(this.type, position);
    }

    deserializeSettingsFormField(field: FieldDataInterface) : SettingsCustomFormFieldData {
        return new fields.SettingsDateV1Field(field.type, field.position, field.id, field.label, field.mandatory, field.active);
    }


    getSettingsComponentType(): Type<fieldComponents.SettingsDateV1FieldComponent> {
        return fieldComponents.SettingsDateV1FieldComponent;
    }

    getFillComponentType(): Type<fieldComponents.FillDateV1FieldComponent> {
        return fieldComponents.FillDateV1FieldComponent;
    }

    getViewComponentType(): Type<fieldComponents.ViewDateV1FieldComponent>{ 
        return fieldComponents.ViewDateV1FieldComponent;
    }


}